import type { InboxFuryWebPort } from "./ports";

export interface RuntimeClientConfiguration {
  production: boolean;
  explicitDemo: boolean;
  hostname: string;
}

export interface RuntimeClientSelection {
  client: InboxFuryWebPort;
  dataMode: "server" | "demo";
}

export function selectRuntimeClient(
  configuration: RuntimeClientConfiguration,
  factories: { bff: () => InboxFuryWebPort },
): RuntimeClientSelection {
  if (configuration.production) {
    if (configuration.hostname !== "app.inboxfury.com") {
      throw new Error("Production InboxFury web must run on app.inboxfury.com.");
    }
    return { client: factories.bff(), dataMode: "server" };
  }
  if (configuration.explicitDemo) {
    throw new Error("The demo client may only be loaded by the development entrypoint.");
  }
  return { client: factories.bff(), dataMode: "server" };
}
